import { ActionIcon } from '@mantine/core';
import { IconArrowDown } from '@tabler/icons-react';
import { COMMENT_SCROLL_BUTTON_ICON_SIZE } from '../constants';
import type { ScrollToBottomButtonProps } from '../types';

export const ScrollToBottomButton = ({
  show,
  onClick,
  className,
}: ScrollToBottomButtonProps) => {
  if (!show) return null;

  return (
    <ActionIcon
      size="lg"
      radius="xl"
      variant="filled"
      onClick={onClick}
      className={className}
    >
      <IconArrowDown size={COMMENT_SCROLL_BUTTON_ICON_SIZE} />
    </ActionIcon>
  );
};
